import { FinanceCertData, IFinanceCertData } from './types';

enum Action {
  GET_SERT = 'actionMakePdf',
  ACTION_TEXT = 'Скачать PDF',
}

const financeCertData = (data: IFinanceCertData): FinanceCertData => {
  return {
    id: data!.id || '',
    childName:
      data!.last_name && data!.first_name
        ? `${data.last_name} ${data.first_name}`
        : 'Без имени',
    isFinanceType: true,
    certificateType: data!.certificate_type,
    certificateNumber: data!.certificate_number,
    certificateDateEnd: data!.certificate_date_end,
    certificateAmountTotal: data!.certificateAmountTotal,
    certificateAmountOnHold: data!.certificateAmountOnHold,
    certificateAmountWithdraw: data!.certificateAmountWithdraw,
    certificateAmountCurrent: data!.certificateAmountCurrent,
    action: Action.GET_SERT,
    actionText: Action.ACTION_TEXT,
    firstName: data!.first_name,
    patroName: data!.patro_name,
    lastName: data!.last_name,
    birthday: data!.birthday,
    certificateDateStart: data!.certificate_date_start,
    municipalityName: data!.municipality_name,
  };
};

export default financeCertData;



// WEBPACK FOOTER //
// ./src/services/pfdod/utils/financeCertData.ts